var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TextareaValidator',{attrs:{"config":{
    label: _vm.control.label,
    name: _vm.control.label,
    validate: _vm.control.required ? 'required' : '',
    value: _vm.value,
  },"onlyBreakAtNewlines":_vm.onlyBreakAtNewlines,"resizeable":_vm.resizeable,"smallInput":_vm.smallInput,"tooltip":_vm.getTooltip()},on:{"InputValidatorModel":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }